<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
      <album-select-group v-model="albumId"></album-select-group>
      <div class="form-group form-row">
        <label class="col-sm-4 col-form-label" :for="safeId('pictureId')">Picture</label>
        <div class="col-sm-8">
          <b-form-select :id="safeId('pictureId')" v-model="pictureId" :options="pictures"
                         text-field="fileName" value-field="pictureId">
          </b-form-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-4 col-form-label" :for="safeId('title')">Title</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('title')" v-model.lazy="title">
        </div>
      </div>
    </window-tab>

    <window-tab title="Settings" icon="cog">
      <template-settings :template-id="templateId"></template-settings>
    </window-tab>
  </window>
</template>

<script>
  import { templateMixin } from '@/mixins'
  import { mapOverlayData, mapTemplateData } from '../../utils/index'

  export default {
    name: 'sponsors',
    mixins: [templateMixin],
    computed: {
      ...mapTemplateData(['albumId', 'pictureId']),
      ...mapOverlayData(['title', 'imageUrl']),
      album () {
        return this.$store.getters.album(this.albumId) || {}
      },
      pictures () {
        return this.album.pictures || []
      }
    },
    watch: {
      pictureId: function (val) {
        this.imageUrl = (this.pictures.find(p => p.pictureId === val) || {}).image
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/sponsors.vue